import { Component, OnInit } from '@angular/core';
import {_HttpClient} from '@delon/theme';
import {SystemContants} from '@core/constants';
import {Output} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {Input} from '@angular/core';

@Component({
  selector: 'app-city-code',
  templateUrl: './city-code.component.html',
  styles: []
})
export class CityCodeComponent implements OnInit {

  @Output()
  codeEvent: EventEmitter<any> = new EventEmitter();
  @Output()
  currentCodeEvent: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  cityCode: any = {
    province: [],
    city: [],
    zone: [],
    provinceSelected: "1",
    citySelected: "1",
    zoneSelected: "1",
  };

  constructor(private http: _HttpClient) { }

  ngOnInit() {
    if (this.cityCode.provinceSelected == 1 || this.cityCode.citySelected == 1 ||
      this.cityCode.zoneSelected == 1) {

      this.loadCityCode(this.cityCode.zoneSelected, (data: any[]) => {
        this.cityCode.province = data;
      });
    } else {
      this.loadCityCode(1, (data: any[]) => {
        this.cityCode.province = data;
      });
      this.loadCityCode(this.cityCode.provinceSelected, (data: any[]) => {
        this.cityCode.city = data;
      });
      this.loadCityCode(this.cityCode.citySelected, (data: any[]) => {
        this.cityCode.zone = data;
      });
    }
  }

  onProvinceChange(code: any) {
    if (code == 1) {
      this.cityCode.city = [];
      this.cityCode.zone = [];
      this.cityCode.citySelected = 1;
      this.cityCode.zoneSelected = 1;
      this.codeEvent.emit(null);
      this.currentCodeEvent.emit(1);
    } else {
      this.loadCityCode(code, (data: any[]) => {
        this.cityCode.city = data;
        this.cityCode.citySelected = 1;
        this.cityCode.zoneSelected = 1;
        this.cityCode.zone = [];
        this.codeEvent.emit(null);
        this.currentCodeEvent.emit(code);
      });
    }
  }

  onCityChange(code: any) {
    if (code == 1) {
      this.cityCode.zone = [];
      this.cityCode.zoneSelected = 1;
      this.codeEvent.emit(null);
      this.currentCodeEvent.emit(this.cityCode.provinceSelected);
    } else {
      this.loadCityCode(code, (data: any[]) => {
        this.cityCode.zone = data;
        this.cityCode.zoneSelected = 1;
        this.codeEvent.emit(null);
        this.currentCodeEvent.emit(code);
      });
    }

  }

  loadCityCode(code: any, callback: any) {
    this.http.get<any>("api/public/city/"+code).subscribe((resp) => {
      if (resp.status === SystemContants.STATUS_SUCCESS) {
        callback(resp.data);
      }
    });
  }

  onZoneChange(code: any) {
    if (code == 1) {
      this.codeEvent.emit(null);
      this.currentCodeEvent.emit(this.cityCode.citySelected);
    } else {
      this.codeEvent.emit(code);
      this.currentCodeEvent.emit(code);
    }

  }


}
